import styled from 'styled-components'
import { VStack } from '../../../global/styles'

export const DonationsWrap = styled(VStack)``

export const ButtonWrap = styled(VStack)`
  margin-bottom: 16px;
  padding: 0 16px;
`
